import React, {useEffect, useState} from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { ContactWidget } from './widgets/contactWidget';
import axios from 'axios';
import './App.css';
import Analytics from './lib/analytics';
import { Localization } from './lib/localization';
const theme = createTheme({
    typography: {
        fontFamily: 'Nunito',
        subtitle1: {
            fontSize: 16,
        },
        body1: {
            fontWeight: 400,
        },
        button: {
            fontWeight: 600,
        },
    },
});

const AnalyticsLayer = new Analytics;

function App() {
    const [loading, setLoading] = useState(true);
    const [widgetData, setWidgetData] = useState(null);

    useEffect(() => {
        console.log("Leadbox v3.8.2 (q.37, s.4)");

        let widgetUUID = window.location.hash.split(";")[0].substr(1);
        let apiUrl = window.location.hash.split(";")[1];
        let isUseMultiProfileEndpoint = window.location.hash.split(";")[2] === "isMultiProfile";

        if (widgetUUID === undefined || widgetUUID === '') {
            const widgetContainer = document.querySelectorAll("[data-bid]")[0];
            widgetUUID = widgetContainer.getAttribute("data-bid");
            apiUrl = widgetContainer.getAttribute("data-url");
            isUseMultiProfileEndpoint = widgetContainer.hasAttribute("data-multi-profile");
        }

        const widgetDataUrl = /\.json$/.test(apiUrl)
            ? apiUrl
            : `${apiUrl}/${isUseMultiProfileEndpoint ? 'customers' : 'widgets'}/${widgetUUID}${isUseMultiProfileEndpoint ? '/widget' : ''}`;

        // const widgetDataUrl = '/public/widget-multi-four-locations.json'; // TODO - dev only

        loading === true && axios
            .get(widgetDataUrl)
            .then(res => {
                Localization.setLang(res.data?.language ?? 'en');
                AnalyticsLayer.setId(res.data.uuid);
                AnalyticsLayer.setTrackingId(res.data?.ga_token);

                // If this API response includes a GA4 Measurement ID, instruct the leadbox.js to grab the GA4 Session ID for us
                const ga4MeasurementId = res.data?.measurementId;
                if (ga4MeasurementId) {
                    AnalyticsLayer.setGa4Secret(res.data?.secret);
                    AnalyticsLayer.setGa4MeasurementId(ga4MeasurementId);
                    window.parent.postMessage({ key: 'ga4-measurement-id', data: ga4MeasurementId }, '*');
                }

                const facebookPixelId = res.data?.fb_pixel_id;
                if (facebookPixelId) {
                    AnalyticsLayer.setFacebookId(facebookPixelId);
                    AnalyticsLayer.setFacebookSecret(res.data?.fb_pixel_token);
                }

                AnalyticsLayer.setProfile(res.data?.vcard?.org ?? null);

                const isLeftAligned = res.data?.primary_cta?.position === 'left';
                if (isLeftAligned) {
                    window.parent.postMessage("isLeftAligned", '*');
                }
                const textChannelData = res.data?.channels?.find(channel => channel.type === "text");

                // This is an override to force the highlight data to show for a specific customer that has a multi profile widget (which otherwise do not have the highlight capability)
                let isForceShowHighlight = false;
                let highlightData = null;
                if (res.data.uuid === '15570941-5506-4931-8c14-b07adb0dee91') {
                    isForceShowHighlight = true;
                    highlightData = {
                        "type": "response_time",
                        "metadata": {
                            "time": 5,
                            "unit": "minutes"
                        }
                    };

                    res.data.primary_cta = { text: 'Text Us' };
                    res.data.secondary_cta = {
                        text: 'Get a Custom Quote',
                        icon: 'task_alt'
                    };
                }

                // An additional override, requested by Aaron for Sherlock Self Storage
                if (res.data.uuid === '721002ac-5cb9-422e-8256-861ca7dd0602') {
                    isForceShowHighlight = true;
                    highlightData = {
                        "type": "response_time",
                        "metadata": {
                            "time": 10,
                            "unit": "minutes"
                        }
                    };

                    res.data.primary_cta = { text: 'Text Us' };
                    res.data.secondary_cta = {
                        text: 'Questions? Just ask',
                        icon: 'chat'
                    };
                }
                const isShowHighlight = (textChannelData?.highlight || isForceShowHighlight) && ! res.data.primary_cta?.is_icon_only;

                highlightData = highlightData ?? textChannelData?.highlight;

                if (isShowHighlight) {
                    window.parent.postMessage("isShowHighlight", '*')
                }

                let widgetData = {
                    ... res.data,
                    ... {
                        isMultiProfile: res.data?.leadboxes?.length > 1,
                        hasChannels: res.data?.channels?.length > 1 && ! res.data?.text_only,
                        apiUrl: apiUrl,
                        isLeftAligned: isLeftAligned,
                        isShowHighlight: isShowHighlight,
                        highlight: isShowHighlight ? highlightData : null,
                        channels: [...(res.data?.channels ?? [])].sort((a, b) => a.order - b.order),
                    },
                }
                setWidgetData(widgetData);
                setLoading(false);
            })
            .catch(err => {
                /* TODO: SEE WHAT TO DO WITH THESE POSSIBLE ERRORS */
                console.log(err);
            })

        const leadboxListener = window.addEventListener(
            'message',
            function (e) {
                var msg = e.data ? e.data : '';

                if (msg.hasOwnProperty('endpoint')) {
                    AnalyticsLayer.setEndpoint(msg.endpoint);
                }

                if (msg.hasOwnProperty('uid')) {
                    AnalyticsLayer.setUserId(msg.uid);
                }

                if (msg.hasOwnProperty('isLoggingEnabled')) {
                    AnalyticsLayer.setIsLoggingEnabled(msg.isLoggingEnabled);
                }

                if (msg.hasOwnProperty('cid')) {
                    AnalyticsLayer.setClientId(msg.cid);
                }

                if (msg.hasOwnProperty('hostname')) {
                    AnalyticsLayer.setHostname(msg.hostname);
                }

                if (msg.hasOwnProperty('href')) {
                    AnalyticsLayer.setHref(msg.href);
                }

                if (msg.hasOwnProperty('path')) {
                    AnalyticsLayer.setPath(msg.path);
                    AnalyticsLayer.trackEvent('leadbox', 'impression-primary-cta');
                }

                if (msg.hasOwnProperty('ga4Session')) {
                    AnalyticsLayer.setGa4Session(msg.ga4Session);
                }

                if (msg.hasOwnProperty('ga4Session')) {
                    AnalyticsLayer.setGa4Session(msg.ga4Session);
                }

                if (AnalyticsLayer.isLoggingEnabled && msg === 'sendTestEvents') {
                    // leadbox
                    AnalyticsLayer.trackEvent('leadbox', 'impression-primary-cta');
                    AnalyticsLayer.trackEvent('leadbox', 'impression-secondary-cta')
                    AnalyticsLayer.trackEvent('leadbox', 'impression-close-cta')
                    AnalyticsLayer.trackEvent('leadbox', 'impression-leadbox');
                    AnalyticsLayer.trackEvent('leadbox', 'close-leadbox');
                    AnalyticsLayer.trackEvent('leadbox', 'form-submitted');

                    // buttons
                    AnalyticsLayer.trackEvent('buttons', 'primary-cta');
                    AnalyticsLayer.trackEvent('buttons', 'secondary-cta');
                    AnalyticsLayer.trackEvent('buttons', 'close-cta');
                    AnalyticsLayer.trackEvent('buttons', 'add-to-contacts-cta')
                    AnalyticsLayer.trackEvent('buttons', 'submit-cta');

                    // channels
                    AnalyticsLayer.trackEvent('channels', 'text');
                    AnalyticsLayer.trackEvent('channels', 'custom');
                    AnalyticsLayer.trackEvent('channels', 'email');
                    AnalyticsLayer.trackEvent('channels', 'call');

                    // form field
                    // missing - email / drop-down ?
                    AnalyticsLayer.trackEvent('form-field', 'name')
                    AnalyticsLayer.trackEvent('form-field', 'phone')
                    AnalyticsLayer.trackEvent('form-field', 'message')
                    AnalyticsLayer.trackEvent('form-field', 'form_start');

                    // form field error
                    // note: message is optional, so we don't send a form-field-error for message
                    AnalyticsLayer.trackEvent('form-field-error', 'name');
                    AnalyticsLayer.trackEvent('form-field-error', 'phone');

                    // Link
                    AnalyticsLayer.trackEvent('link', 'privacy-policy')
                    AnalyticsLayer.trackEvent('search', 'the search term on blur')
                    AnalyticsLayer.trackEvent('form-field', 'location search')
                    AnalyticsLayer.trackEvent('profile', 'the profile label');
                }
            },
            false
        );

        return () => {
            window.removeEventListener('resize', leadboxListener)
        };
    }, []);

    return (!loading && widgetData !== null) && (
        <ThemeProvider theme={theme}>
            <ContactWidget data={widgetData} Analytics={AnalyticsLayer} />
        </ThemeProvider>
    );
}

export default App;
